import { ROUTE_PATH } from '../../routes/paths';

/** Top-level tab bar for the Personas admin area (KINDLY-955 Phase 0). */
export const PERSONA_TABS = [
  { path: ROUTE_PATH.PERSONAS, heading: 'Catalog' },
  { path: ROUTE_PATH.PERSONAS_SHARED_RULES, heading: 'Shared Rules' },
];

/** Per-persona detail tabs. Paths use `:personaId` for react-router. */
export const PERSONA_DETAIL_TABS = (personaId: string | number) => [
  { path: `/personas/${personaId}/overview`, heading: 'Overview' },
  { path: `/personas/${personaId}/clients`, heading: 'Clients' },
  { path: `/personas/${personaId}/rules`, heading: 'Rules' },
  { path: `/personas/${personaId}/evals`, heading: 'Evals' },
  { path: `/personas/${personaId}/prompts`, heading: 'Prompts' },
  { path: `/personas/${personaId}/chat`, heading: 'Chat' },
];
